import { roles } from "../config/config";

export const assistantPermissions = [roles.developer];
